<template>
  <el-dialog :visible.sync="innerVisible" :title="$t('FbaJob.BookingAudit')" width="720px" custom-class="cargo-form-dialog" :close-on-click-modal="false" @close="handleClose">
    <el-form ref="form" label-width="110px" label-position="left" class="cargo-form">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label-width="0" class="auto-width">
            <el-radio-group v-model="radioType">
              <el-radio :label="1">{{ $t('FbaJob.UseNewNo') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.OperationCompany') }}：</span>
            <cargo-office-select
              :clearable="false"
              :disabled="!job.opOfficeUpdate"
              :have-hq="false"
              :office-id="Number(job.opOffice)"
              tooltip
              @change="p=>{job.opOffice=p.value;officeChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.Operation')+'：'">
            <cargo-user-select
              :disabled="!job.opUpdate"
              :method-params="{officeId:job.opOffice,category:'role',shape:'op'}"
              :default-value="job.op||''"
              @change="p=>{job.op=p.value;opChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.OperationDepartment') }}：</span>
            <cargo-department-select
              :office-id="Number(job.opOffice) || $store.getters.currentOfficeId"
              :department-id="Number(job.opDepartment)"
              :disabled="!job.opDepartmentUpdate"
              @change="p=>{job.opDepartment=p.value}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('SeaExport.CustomerService')+'：'">
            <cargo-user-select
              ref="csr"
              :method-params="{officeId:job.salesOffice,category:'role',shape:'csr'}"
              :disabled="!job.csrUpdate"
              :default-value="job.csr||''"
              @change="p=>{job.csr=p.value;csrChangeHandler(p)}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item>
            <span slot="label" class="blue">{{ $t('FbaJob.ShippingType') }}：</span>
            <el-select :value="job.shippingType" :disabled="!hasFbaChannel && !job.shippingTypeUpdate" filterable @change="changeShippingType">
              <el-option
                v-for="(item,index) in FbaJobConstants.SHIPPING_TYPES"
                :key="index"
                :label="$store.getters.language === 'zh' ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('FbaJob.IncoTerm')+'：'">
            <cargo-advance-select
              no="incoTerm"
              :disabled="!job.incoTermUpdate"
              :select-type="selectTypeNames.basic_data_IncoTerm"
              filterable
              :clearable="false"
              :default-value="job.incoTerm"
              @parentCallBack="p=>{job.incoTerm=p.value}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item>
            <span slot="label" class="blue">{{ $t('FbaJob.DomesticWarehouse') }}：</span>
            <cargo-company-select
              :method-params="{warehouse:true,active:true}"
              :disabled="!job.domesticWarehouseUpdate"
              :default-value="Number(job.domesticWarehouse)||''"
              @change="p=>{job.domesticWarehouse=p.value}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('FbaJob.overseaWarehouse')+'：'">
            <cargo-advance-select
              no="overseaWarehouseCode"
              :disabled="!job.overseaWarehouseCodeUpdate"
              :select-type="selectTypeNames.basic_data_OverseaWarehouse"
              filterable
              :method-params="{ifFba:false}"
              :clearable="false"
              tag-name="countryChineseName"
              tag-value="warehouseCode"
              :default-value="job.overseaWarehouseCode"
              style="width:100%;"
              @parentCallBack="p=>{job.overseaWarehouseCode=p.value}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!--      <el-row :gutter="10">-->
      <!--        <el-col :span="12">-->
      <!--          <el-form-item>-->
      <!--            <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_Destination') }}：</span>-->
      <!--            <el-tooltip :content="job.warehouseCode" placement="bottom-end">-->
      <!--              <el-cascader-->
      <!--                v-model="job.warehouseCode"-->
      <!--                no="warehouseCode"-->
      <!--                :disabled="!job.warehouseCodeUpdate"-->
      <!--                style="width:100%;"-->
      <!--                :options="destinations"-->
      <!--                filterable-->
      <!--                :clearable="true"-->
      <!--                @focus="JobUtils.focusWarehouseCode(job)"-->
      <!--                @blur="JobUtils.blurWarehouseCode(job)"-->
      <!--                @change="p=>{JobUtils.warehouseCodeHandler(job, p);}"-->
      <!--              />-->
      <!--            </el-tooltip>-->
      <!--          </el-form-item>-->
      <!--        </el-col>-->
      <!--        <el-col :span="12">-->
      <!--          <el-form-item :label="$t('FbaJob.DestinationDistribution')+'：'">-->
      <!--            <cargo-advance-select-->
      <!--              no="destinationDistribution"-->
      <!--              :disabled="!job.destinationDistributionUpdate"-->
      <!--              :select-type="selectTypeNames.local_cache_FbaJobConstants$ORDER_DESTINATION_DISTRIBUTION_TYPES"-->
      <!--              filterable-->
      <!--              :clearable="false"-->
      <!--              :default-value="job.destinationDistribution"-->
      <!--              @parentCallBack="p=>{job.destinationDistribution = p.value}"-->
      <!--            />-->
      <!--          </el-form-item>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
      <!--      <el-row :gutter="10">-->
      <!--        <el-col :span="12">-->
      <!--          <el-form-item :label="$t('FbaJob.ServiceChannel')+'：'">-->
      <!--            <el-select v-model="job.serviceChannel" filterable clearable :disabled="!job.serviceChannelUpdate" @change="changeServiceChannel">-->
      <!--              <el-option-->
      <!--                v-for="(item,index) in channel4JobSelect"-->
      <!--                :key="index"-->
      <!--                :label="item.channelName"-->
      <!--                :value="item.channelName"-->
      <!--              />-->
      <!--            </el-select>-->
      <!--          </el-form-item>-->
      <!--        </el-col>-->
      <!--        <el-col :span="12">-->
      <!--          <el-form-item :label="$t('FbaJob.ChargingMethod')+'：'">-->
      <!--            <el-radio-group v-model="job.chargingMethod" :disabled="!job.chargingMethodUpdate">-->
      <!--              <el-radio :label="0">{{ 'KG' }}</el-radio>-->
      <!--              <el-radio :label="1">{{ 'CBM' }}</el-radio>-->
      <!--            </el-radio-group>-->
      <!--          </el-form-item>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
      <!--      <el-row :gutter="10">-->
      <!--        <el-col :span="12">-->
      <!--          <el-form-item :label="$t('FbaJob.BubbleCountingRatio')+'：'">-->
      <!--            <el-input v-model="job.bubbleCountingRatio" style="width: 60px;" :disabled="!job.bubbleCountingRatioUpdate" />-->
      <!--          </el-form-item>-->
      <!--        </el-col>-->
      <!--        <el-col :span="12">-->
      <!--          <el-form-item :label="$t('FbaJob.BubbleSplittingRatio')+'：'">-->
      <!--            <el-input-number v-model="job.bubbleSplittingRatio" style="width: 75px;" controls-position="right" :disabled="!job.bubbleSplittingRatioUpdate" :max="100" :min="0" :precision="0" />-->
      <!--            <span style="margin-left: 1px;">%</span>-->
      <!--          </el-form-item>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item v-if="job.shippingType === 'SE' || job.shippingType === 'RE'">
            <span slot="label" class="blue">{{ $t('SeaExport.FLCLType') }}：</span>
            <cargo-advance-select
              no="containerLoadType"
              :disabled="!job.containerLoadTypeUpdate"
              :select-type="selectTypeNames.local_cache_FbaJobConstants$FBA_CONTAINER_LOAD_TYPES"
              filterable
              :clearable="false"
              :default-value="job.containerLoadType"
              @parentCallBack="p=>{job.containerLoadType=p.value}"
            />
          </el-form-item>
          <el-form-item v-if="job.shippingType === 'AE'">
            <span slot="label" class="blue">{{ $t('SeaExport.OperateType') }}</span>
            <cargo-advance-select
              no="operateType"
              :disabled="!job.operateTypeUpdate"
              :clearable="false"
              filterable
              :select-type="selectTypeNames.local_cache_AirExportConstants$BUSINESS_MODELS"
              :default-value="job.operateType"
              @parentCallBack="p=>{job.operateType=p.value}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="(job.shippingType === 'SE' || job.shippingType === 'RE') && job.containerLoadType === 'LCL'" :label="$t('FbaJob.LclMethod')+'：'">
            <el-radio-group v-model="job.lclMethod">
              <el-radio :label="'LCL'">{{ '自拼箱' }}</el-radio>
              <el-radio :label="'BB'">{{ '委托拼箱' }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="job.shippingType === 'AE'">
            <span slot="label" class="blue">{{ $t('SeaExport.BookingProperty') }}</span>
            <cargo-advance-select
              no="bookingTerm"
              :disabled="!job.bookingTermUpdate"
              filterable
              :clearable="false"
              :select-type="selectTypeNames.local_cache_BookingTerm"
              :default-value="job.bookingTerm"
              :fields="['chineseName']"
              @parentCallBack="p=>{job.bookingTerm=p.value}"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$t('SeaExport.Remarks')+'：'">
            <el-input v-model="job.remarks" type="textarea" :disabled="!job.remarksUpdate" :rows="2" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" style="padding:10px;">
      <el-button type="primary" @click="handleSubmit">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button @click="handleClose">{{ $t('SeaExport.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import CargoForm from '@/components/Cargo/Common/CargoForm'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { Company } from '@/class/model/mdm/Company'
import { cacheName, cache } from '@/utils/cacheManager'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getFbaJob } from '@/api/Fba/fbaJob'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { getJobAvailableChannels } from '@/api/Fba/fbaChannel'
import { FbaQuotation } from '@/class/model/price/FbaQuotation'
import * as FbaJobConstants from '@/class/cargo/model/parameters/FbaJobConstants'
import StrUtils from '@/utils/StrUtils'

export default {
  name: 'FbaOpVerifyFrameDialog',
  components: { cargoDepartmentSelect, cargoOfficeSelect, cargoUserSelect, cargoCompanySelect, cargoAdvanceSelect, CargoForm },
  props: {
    visible: { type: Boolean, default: () => false },
    jobModel: { type: Object, default: () => ({}) },
    jobList: { type: Array, default: () => ([]) },
    submitCallBack: { type: Function, default: () => null }
  },
  data() {
    return {
      TYPE_NAMES,
      FbaJobConstants,
      hasFbaChannel: false,
      job: {
        opOffice: 0,
        opOfficeUpdate: true,
        op: 0,
        opUpdate: true,
        opDepartment: 0,
        opDepartmentUpdate: true,
        csr: 0,
        csrUpdate: true,
        shippingType: 'SE',
        shippingTypeUpdate: true,
        incoTerm: '',
        incoTermUpdate: true,
        serviceChannel: '',
        serviceChannelUpdate: true,
        chargingMethod: 0,
        chargingMethodUpdate: true,
        bubbleCountingRatio: '',
        bubbleCountingRatioUpdate: true,
        bubbleSplittingRatio: '',
        bubbleSplittingRatioUpdate: true,
        remarks: '',
        remarksUpdate: true,
        domesticWarehouse: '',
        domesticWarehouseUpdate: true,
        overseaWarehouseCode: '',
        overseaWarehouseCodeUpdate: true,
        warehouseCode: '',
        warehouseCodeUpdate: true,
        destinationDistribution: '',
        destinationDistributionUpdate: true,
        containerLoadType: '',
        containerLoadTypeUpdate: true,
        operateType: 0,
        operateTypeUpdate: true,
        bookingTerm: '',
        bookingTermUpdate: true,
        lclMethod: ''
      },
      selectTypeNames: TYPE_NAMES,
      channel4JobSelect: [],
      fbaQuotation: null,
      fbaChannel: null,
      isTrustFrom: false,
      innerVisible: false,
      radioType: 1, // 默认选中项
      JobUtils
    }
  },
  computed: {
    destinations() { // 目的地 可选项
      return JobUtils.initDestination()
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          await this.init()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
  },
  methods: {
    async init() {
      Object.assign(this.job, this.jobModel)
      const dbJob = await getFbaJob({ uuid: this.jobModel.uuid }).then((res) =>
        res.data ? res.data : null
      )
      if (dbJob) Object.assign(this.job, dbJob)
      this.job.opOffice = this.job.opOffice || 1
      this.job.chargingMethod = Number(this.job.chargingMethod) || 0
      this.isTrustFrom = await this.checkTrustFrom()
      this.job.lclMethod = 'LCL'
      if (this.job.shippingType === 'AE') {
        this.job.bookingTerm = 'SB'
      }
      this.hasFbaChannel = false
      const deps = getCacheListByKey(basicCacheKeys.basic_data_Department)
      let officeId = ''
      if (this.job.opDepartment && this.job.opDepartment > 0 && deps && deps.length > 0) {
        let officeUuid = ''
        const dep = deps.find(p => p.departmentId === this.job.opDepartment)
        if (dep) officeUuid = dep.officeUuid
        if (officeUuid) {
          const officeList = getCacheListByKey(basicCacheKeys.basic_data_Office)
          const office = officeList.find(p => p.uuid === officeUuid)
          if (office) officeId = office.officeId
        }
      }
      if ((officeId && officeId !== this.job.opOffice)) {
        this.job.opDepartment = 0
      }
      getJobAvailableChannels({ tenantId: this.tenantId }).then(res => {
        if (this.job.shippingType) {
          this.channel4JobSelect = res.data.filter(e => e.shippingType === this.job.shippingType)
        } else {
          this.channel4JobSelect = res.data
        }
      })
      this.checkCanUpdateField()
    },
    checkCanUpdateField() {
      let existEmptyDomesticWarehouse = false
      this.job.opOfficeUpdate = true
      this.job.opUpdate = true
      this.job.opDepartmentUpdate = true
      this.job.csrUpdate = true
      for (const job of this.jobList) {
        if (!this.hasFbaChannel) {
          if (job.serviceChannel) {
            this.hasFbaChannel = true
            this.job.shippingTypeUpdate = false
          } else {
            this.job.shippingTypeUpdate = this.job.shippingTypeUpdate ? job.shippingType === this.jobModel.shippingType : this.job.shippingTypeUpdate
          }
        }
        this.job.incoTermUpdate = this.job.incoTermUpdate ? job.incoTerm === this.jobModel.incoTerm : this.job.incoTermUpdate
        this.job.serviceChannelUpdate = this.job.serviceChannelUpdate ? job.serviceChannel === this.jobModel.serviceChannel : this.job.serviceChannelUpdate
        this.job.chargingMethodUpdate = this.job.chargingMethodUpdate ? job.chargingMethod === this.jobModel.chargingMethod : this.job.chargingMethodUpdate
        this.job.bubbleCountingRatioUpdate = this.job.bubbleCountingRatioUpdate ? job.bubbleCountingRatio === this.jobModel.bubbleCountingRatio : this.job.bubbleCountingRatioUpdate
        this.job.bubbleSplittingRatioUpdate = this.job.bubbleSplittingRatioUpdate ? job.bubbleSplittingRatio === this.jobModel.bubbleSplittingRatio : this.job.bubbleSplittingRatioUpdate
        this.job.remarksUpdate = this.job.remarksUpdate ? job.remarks === this.jobModel.remarks : this.job.remarksUpdate
        if (!existEmptyDomesticWarehouse) {
          if (!job.domesticWarehouse) {
            existEmptyDomesticWarehouse = true
            this.job.domesticWarehouseUpdate = true
          } else {
            this.job.domesticWarehouseUpdate = this.job.domesticWarehouseUpdate ? job.domesticWarehouse === this.jobModel.domesticWarehouse : this.job.domesticWarehouseUpdate
          }
        }
        this.job.overseaWarehouseCodeUpdate = this.job.overseaWarehouseCodeUpdate ? job.overseaWarehouseCode === this.jobModel.overseaWarehouseCode : this.job.overseaWarehouseCodeUpdate
        this.job.warehouseCodeUpdate = this.job.warehouseCodeUpdate ? job.warehouseCode === this.jobModel.warehouseCode : this.job.warehouseCodeUpdate
        this.job.destinationDistributionUpdate = this.job.destinationDistributionUpdate ? job.destinationDistribution === this.jobModel.destinationDistribution : this.job.destinationDistributionUpdate
        if (this.job.shippingTypeUpdate) {
          this.job.containerLoadTypeUpdate = this.job.containerLoadTypeUpdate ? job.containerLoadType === this.jobModel.containerLoadType : this.job.containerLoadTypeUpdate
        } else {
          this.job.containerLoadTypeUpdate = false
        }
        this.job.operateTypeUpdate = this.job.operateTypeUpdate ? job.operateType === this.jobModel.operateType : this.job.operateTypeUpdate
        this.job.bookingTermUpdate = this.job.bookingTermUpdate ? job.bookingTerm === this.jobModel.bookingTerm : this.job.bookingTermUpdate
      }
    },
    // 非委托单｛ job.salesOffice=当前分公司
    // and (job.trustFromJob is null or job.trustFromJob = '') and 委托单位不是内部公司)｝
    // 则客服跟销售公司，允许修改操作公司，否则委托单客服跟操作公司，不允许修改操作公司
    async checkTrustFrom() {
      const company = await Company.getCompanyById(this.job.customerId)
      const currentOfficeId = this.$store.getters.currentOfficeId
      if (this.job.salesChannel === 'B2B') { return false }
      if ((this.job.salesOffice && parseInt(this.job.salesOffice) === currentOfficeId && !this.job.trustFromJob && company && company.linkedBranchId === 0) || (this.job.salesOffice === 1)) {
        return false // 非委托单
      }
      return true
    },
    changeShippingType(shippingType) {
      if (this.job.shippingTypeUpdate) {
        this.job.shippingType = shippingType
      } else {
        let title = ''
        if (this.jobList.length > 1) {
          title = this.$t('FbaJob.changeVerifyMultipleShippingType')
        } else {
          const job = this.jobList[0]
          let shippingTypeStr = ''
          switch (job.shippingType) {
            case 'SE':
              shippingTypeStr = '海运'
              break
            case 'AE':
              shippingTypeStr = '空运'
              break
            case 'RE':
              shippingTypeStr = '铁路'
              break
          }
          title = StrUtils.substitute(this.$t('FbaJob.changeVerifyShippingType'), [job.serviceChannel, shippingTypeStr])
        }
        this.$alert(title, this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          type: 'warning'
        })
      }
      if (this.job.shippingType === 'SE' || this.job.shippingType === 'RE') {
        this.job.chargingMethod = 1
        this.job.operateType = ''
        this.job.bookingTerm = ''
      } else if (this.job.shippingType === 'AE') {
        this.job.chargingMethod = 0
        this.job.operateType = 0
        this.job.bookingTerm = 'SB'
      }
    },
    async changeServiceChannel() {
      await this.changeChannelName()
      if (this.fbaChannel) {
        this.syncJobInfoByChannel()
      } else {
        this.job.chargingMethodUpdate = true
        this.job.shippingTypeUpdate = true
        this.job.destinationDistributionUpdate = true
        this.job.bubbleCountingRatioUpdate = true
        this.job.bubbleSplittingRatioUpdate = true
        this.checkCanUpdateField()
      }
    },
    async changeChannelName() {
      const channel = this.channel4JobSelect.find(e => this.job.serviceChannel === e.channelName)
      if (channel) {
        this.fbaChannel = channel
        this.fbaQuotation = new FbaQuotation().fillDefaultValue().getData()
        this.fbaQuotation.uuid = channel.quotationUuid
        const jobModel = new FbaQuotation(this.fbaQuotation)
        await jobModel.loadFbaQuotationRelated({
          quotation: true,
          label: true,
          partitionSetting: true,
          setupSetting: true,
          charge: true,
          customerPrice: true
        })
      } else {
        this.fbaChannel = null
        this.fbaQuotation = null
      }
    },
    syncJobInfoByChannel() {
      this.job.chargingMethod = this.fbaChannel.chargingMethod
      this.job.shippingType = this.fbaChannel.shippingType
      this.job.destinationDistribution = this.fbaChannel.destinationDistribution + ''
      this.job.bubbleCountingRatio = this.fbaChannel.bubbleCountingRatio
      this.job.bubbleSplittingRatio = this.fbaChannel.bubbleSplittingRatio
      this.job.chargingMethodUpdate = false
      this.job.shippingTypeUpdate = false
      this.job.destinationDistributionUpdate = false
      this.job.bubbleCountingRatioUpdate = false
      this.job.bubbleSplittingRatioUpdate = false
    },
    // 切换分公司
    officeChangeHandler() {
      if (!this.job.opOffice || this.job.opOffice <= 0) {
        this.job.opOffice = this.$store.getters.currentOfficeId
      }
    },
    // 选择操作时，获取操作分公司
    opChangeHandler(user) {
      if (user.defaultDepId > 0) {
        this.job.opDepartment = user.defaultDepId
      } else {
        if (this.job.opOffice > 0) {
          new User(user).getUserDefaultDepartmentByOffice('role', 'op', this.job.opOffice).then(dep => {
            this.job.opDepartment = dep ? dep.departmentId : 0
          })
        } else {
          new User(user).getDefaultDepartment('role', 'op', this.job.opOffice).then(dep => {
            this.job.opDepartment = dep ? dep.departmentId : 0
          })
        }
      }
    },
    // 客服改变
    async csrChangeHandler(data) {
      this.job.csr = data.value
      this.job.csrDepartment = 0
      this.job.csrOffice = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'csr')
        if (dep) {
          this.job.csrDepartment = dep.departmentId
          const office = await Office.getOfficeByUuid(dep.officeUuid)
          this.job.csrOffice = office ? office.officeId : 0
        }
      }
    },
    handleSubmit() {
      if (!this.job.opOffice || this.job.opOffice === 1 || this.job.opOffice <= 0) {
        this.$message.warning(this.$t('SeaExport.OperationCompanyCannotBeEmpty'))
        return
      }
      if (!this.job.opDepartment || this.job.opDepartment <= 0) {
        this.$message.warning(this.$t('SeaExport.OperationDepartmentCannotBeEmpty'))
        return
      }
      if (!this.job.domesticWarehouse || this.job.domesticWarehouse <= 0) {
        this.$message.warning(this.$t('FbaJob.DomesticWarehouseCannotBeEmpty'))
        return
      }
      // if (!this.job.warehouseCode) {
      //   this.$message.warning(this.$t('FbaJob.WarehouseCodeCannotBeEmpty'))
      //   return
      // }
      if ((this.job.shippingType === 'SE' || this.job.shippingType === 'RE') && !this.job.containerLoadType) {
        this.$message.warning(this.$t('FbaJob.ContainerLoadTypeCannotBeEmpty'))
        return
      }
      if (this.job.shippingType === 'AE' && typeof this.job.operateType !== 'number') {
        this.$message.warning(this.$t('FbaJob.OperateTypeCannotBeEmpty'))
        return
      }
      if (this.job.shippingType === 'AE' && !this.job.bookingTerm) {
        this.$message.warning(this.$t('FbaJob.BookingTermCannotBeEmpty'))
        return
      }
      if (!this.job.shippingType) {
        this.$message.warning(this.$t('FbaJob.ShippingTypeCannotBeEmpty'))
        return
      }
      if (!(typeof this.job.chargingMethod === 'number')) {
        this.$message.warning(this.$t('FbaJob.ChargingMethodCannotBeEmpty'))
        return
      }
      const form = {}
      form.opOffice = this.job.opOffice || 0
      form.opOfficeUpdate = this.job.opOfficeUpdate
      form.op = this.job.op || 0
      form.opUpdate = this.job.opUpdate
      if (this.job.opDepartment && this.job.opDepartment > 0) {
        form.opDepartment = this.job.opDepartment || 0
      }
      form.opDepartmentUpdate = this.job.opDepartmentUpdate
      form.csr = this.job.csr || 0
      form.csrUpdate = this.job.csrUpdate
      form.shippingType = this.job.shippingType
      form.shippingTypeUpdate = this.job.shippingTypeUpdate
      form.incoTerm = this.job.incoTerm
      form.incoTermUpdate = this.job.incoTermUpdate
      form.serviceChannel = this.job.serviceChannel
      form.serviceChannelUpdate = this.job.serviceChannelUpdate
      form.chargingMethod = this.job.chargingMethod || 0
      form.chargingMethodUpdate = this.job.chargingMethodUpdate
      form.bubbleCountingRatio = this.job.bubbleCountingRatio
      form.bubbleCountingRatioUpdate = this.job.bubbleCountingRatioUpdate
      form.bubbleSplittingRatio = this.job.bubbleSplittingRatio
      form.bubbleSplittingRatioUpdate = this.job.bubbleSplittingRatioUpdate
      form.remarks = this.job.remarks
      form.remarksUpdate = this.job.remarksUpdate
      form.domesticWarehouse = this.job.domesticWarehouse
      form.domesticWarehouseUpdate = this.job.domesticWarehouseUpdate
      form.overseaWarehouseCode = this.job.overseaWarehouseCode
      form.overseaWarehouseCodeUpdate = this.job.overseaWarehouseCodeUpdate
      form.warehouseCode = this.job.warehouseCode
      form.warehouseCodeUpdate = this.job.warehouseCodeUpdate
      form.destinationDistribution = this.job.destinationDistribution
      form.destinationDistributionUpdate = this.job.destinationDistributionUpdate
      form.containerLoadType = this.job.containerLoadType
      form.containerLoadTypeUpdate = this.job.containerLoadTypeUpdate
      form.operateType = this.job.operateType
      form.operateTypeUpdate = this.job.operateTypeUpdate
      form.bookingTerm = this.job.bookingTerm
      form.bookingTermUpdate = this.job.bookingTermUpdate
      form.lclMethod = this.job.lclMethod
      this.submitCallBack(form)
      this.handleClose()
    },
    handleClose() {
      this.innerVisible = false
    }
  }
}
</script>
<style lang="scss">
.cargo-form-dialog{
  .el-dialog{
    &__header,&__body,&__footer{
      padding:10px 15px!important;
    }
    &__title{
      vertical-align: middle;
    }
    &__headerbtn{
      top:15px;
      right:15px;
    }
  }
}
.cargo-form{
  .el-form-item {
    &.red-input{
      .el-input__inner{
        color: #E9650E;
      }
    }
    &__content{
      width: auto!important;
    }
    &.label-none {
      .el-form-item__content{
        margin-left: 0;
      }
    }
  }
}
</style>
